import { Location } from 'react-router-dom';
import { FormTabs } from '../DeclarationFormTab';

export const getFormActiveTabKey = (location: Location, baseUrl: string): FormTabs => {
    if (location.pathname === baseUrl) return FormTabs.MASTER_DETAILS;
    else if (location.pathname.includes(FormTabs.MASTER_ITEMS)) return FormTabs.MASTER_ITEMS;
    else if (location.pathname.includes(FormTabs.HOUSE_CONSIGNMENTS)) return FormTabs.HOUSE_CONSIGNMENTS;
    else if (location.pathname.includes(FormTabs.PRODUCTS)) return FormTabs.PRODUCTS;
    else return FormTabs.MASTER_DETAILS;
};
